import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

// ReactDOM.createRoot(document.querySelector('div#root')).render(<App />)
// ReactDOM.createBlockingRoot(document.querySelector('div#root')).render(<App />)
ReactDOM.render(<App />, document.querySelector('div#root'))
